import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

const faqs = [
  { q: "Berapa lama durasi CapCut Pro ini?", a: "Durasi penuh 1 bulan (30 hari) sejak akun dikirim dan aktif. Bisa diperpanjang dengan order kembali menjelang habis." },
  { q: "Bisa dipakai di perangkat apa saja?", a: "Bisa di HP (Android/iOS), Laptop (Windows/Mac), maupun PC. Login dengan 1 perangkat sesuai kebutuhanmu." },
  { q: "Bagaimana proses pengirimannya?", a: "Setelah pembayaran selesai, detail akun langsung dikirim melalui WhatsApp secara instan — tanpa nunggu lama." },
  { q: "Apakah project atau editan saya aman?", a: "Aman. Semua project dapat muncul kembali sesuai sistem sinkronisasi CapCut, jadi kamu nggak perlu khawatir kehilangan hasil kerja." },
  { q: "Akunnya dari mana?", a: "Akun disediakan langsung dari penjual — kamu tinggal login dan semua fitur Pro langsung terbuka tanpa setup apa pun." },
  { q: "Apa saja fitur Pro yang terbuka?", a: "Semua: ekspor tanpa watermark hingga 4K, template & efek premium, AI Tools, Auto Captions, filter & transisi pro, serta update fitur terbaru." },
];

export const CapCutFAQ = () => (
  <section className="py-24 bg-[#F8FAFC]" id="capcut-faq">
    <div className="max-w-3xl mx-auto px-6 sm:px-8">
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="font-capcut-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-slate-900 text-center mb-12"
      >
        Masih ragu? <span className="text-blue-600">Cek dulu di sini</span>.
      </motion.h2>

      <Accordion type="single" collapsible className="space-y-3" data-testid="capcut-faq-accordion">
        {faqs.map((faq, i) => (
          <AccordionItem
            key={i}
            value={`capcut-faq-${i}`}
            className="rounded-2xl bg-white border border-slate-200 px-5 sm:px-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] data-[state=open]:border-blue-300"
          >
            <AccordionTrigger className="text-left font-capcut-heading font-bold text-slate-900 text-sm md:text-base hover:no-underline py-5" data-testid={`capcut-faq-trigger-${i}`}>
              {faq.q}
            </AccordionTrigger>
            <AccordionContent className="text-slate-600 text-sm md:text-base leading-relaxed pb-5">{faq.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
